import React, { FunctionComponent, ReactElement } from 'react';

import { BUTTON_SIZE } from '../BUTTON_SIZE';
import { BUTTON_STYLE } from '../BUTTON_STYLE';

import { ButtonSizer } from './ButtonSizer.component';
import { IButtonSkinProps } from './IButtonSkinProps';
import { LinkButton } from './LinkButton.component';
import { PrimaryButton } from './PrimaryButton.component';
import { SecondaryButton } from './SecondaryButton.component';

const skins: Record<BUTTON_STYLE, FunctionComponent<IButtonSkinProps>> = {
    [BUTTON_STYLE.PRIMARY]: PrimaryButton,
    [BUTTON_STYLE.SECONDARY]: SecondaryButton,
    [BUTTON_STYLE.LINK]: LinkButton,
};

export function ButtonSkin (props: IButtonSkinProps): ReactElement {
    const {
        style = BUTTON_STYLE.PRIMARY,
        size = BUTTON_SIZE.DEFAULT,
        children,
        ...skinProps
    }: IButtonSkinProps = props;

    const Skin: FunctionComponent<IButtonSkinProps> = skins[style];

    return (
        <Skin {...skinProps}>
            <ButtonSizer size={size}>
                {children}
            </ButtonSizer>
        </Skin>
    );
}
